"use client";

import { Clock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SrokZaPriemaneNaPorachki() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return;
}